export default __webpack_public_path__ + "static/media/baseline-signal_cellular_1_bar-24px.bc584ea5.svg";